export function sameMonth(d1: Date, d2: Date) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth();
}

export function sameDate(d1: Date, d2: Date) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

export function addDays(date: Date, days: number) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function addMonths(date: Date, months: number) {
  const result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}

export function latestDate(d1: Date, d2: Date) {
  return d1 > d2 ? d1 : d2;
}

export function isDatePast(date: Date) {
  return date < new Date();
}

export function firstDayOfMonth(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function lastDayOfMonth(date: Date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

// JS assumes a date string like `2024-10-01` is in midnight UTC time, so we need to convert it to midnight local time
export function dateOnlyToLocalMidnight(dateOnly: string) {
  return new Date(`${dateOnly}T00:00:00`);
}

/**
 * Gets the difference in minutes between local time and a given timezone string.
 */
export function getOffsetDiffMinutes(timeZone: string, date = new Date()) {
  const getOffset = (tz: string) => {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
      .formatToParts(date)
      .reduce(
        (acc, p) => {
          acc[p.type] = p.value;
          return acc;
        },
        {} as Record<keyof Intl.DateTimeFormatPartTypesRegistry, string>,
      );

    const asUTC = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour % 24, +parts.minute, +parts.second);
    return (asUTC - date.getTime()) / 60000;
  };

  const localTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return getOffset(timeZone) - getOffset(localTz);
}
